export default function Marquee({ items = [] }) {
  if (!items.length) return null;
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span className="whitespace-nowrap px-7 font-serif text-xl italic text-ivory/85 sm:text-2xl">{item}</span>
          <span className="text-[9px] text-gold">◆</span>
        </span>
      ))}
    </div>
  );
  return (
    <div className="overflow-hidden border-y border-charcoal/10 bg-charcoal py-5" data-testid="editorial-marquee">
      <div className="marquee-track">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
